import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";

export const HeaderContainer = styled.header`
  height: 43px;
  width: calc(100% - 32px);
  margin: 16px;
  display: flex;
  align-items: center;
  position: relative;
  &>.title{
    width: 100%;
    text-align: center;
    right: 0;
    z-index: -1;
    position: absolute;
    font-size: ${Variables.font_sizes.x4_large};
    color: ${Variables.colors.complementary_700};
  }
`;
